import { ParentBrandPopover } from './parent-brand-popover';

export { ParentBrandPopover };
